import { render } from "./CustomIcon.vue?vue&type=template&id=659e779e&scoped=true"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-659e779e"

export default script